import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import Layout from "./Layout";
import Chat from "./Chat";
import HomeQRFlow from "./HomeQRFlow";
import HomeReplyBot from "./HomeReplyBot";
import Container from "@mui/material/Container";

const Home = () => {
  const context = useContext(AppContext);
  const intl = useIntl();
  const chatRef = useRef();
  const [tenantConfig, setTenantConfig] = useState(null);
  const shopId = 1; // BUG: this should be dynamic

  useEffect(() => {
    if (context) {
      setTenantConfig(context.tenantConfig);
      context.updateBreadcrumbsState([]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  let mainComponent;
  if (tenantConfig?.appId === "qrflow") {
    mainComponent = <HomeQRFlow chatRef={chatRef} />;
  } else if (tenantConfig?.appId === "replybot") {
    mainComponent = <HomeReplyBot chatRef={chatRef} />;
  } else {
    mainComponent = <div />;
  }

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        {mainComponent}
        <Chat shopId={shopId} ref={chatRef} />
      </Container>
    </Layout>
  );
};

export default Home;
